var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('BaseDialog',{attrs:{"title":_vm.displayText.title,"hideCancel":"","show-close":false},on:{"confirm":_vm.onConfirm}},[_c('div',{staticStyle:{"padding-bottom":"40px"}},[_vm._v(" "+_vm._s(_vm.displayText.content)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }